import React from "react";
import { css } from "@emotion/react";
const sqlTableLayout = css`
  table,
  th,
  td {
    border: 1px solid #dddfe1;
    border-collapse: collapse;
    width: unset;
  }

  table td,
  table th {
    padding: 5px;
  }
  table thead th {
    background-color: #333333;
    color: #ffffff;
  }
  table tbody td {
    color: #636363;
  }
  table tbody tr {
    background-color: #f9fafb;
  }
  table tbody tr:nth-of-type(odd) {
    background-color: #ffffff;
  }

  table {
    margin-right: 2em;
  }

  display: inline-table;
`;

const sqlTableTitle = css`
  font-weight: 500;
`;

export function SQLTable({ children, title }) {
  return (
    <div css={sqlTableLayout}>
      <p css={sqlTableTitle}>{title}</p>
      {children}
    </div>
  );
}
